import React, { useState } from "react";
import { SectionHeading } from "../components/SectionHeading";
import { GALLERY, GALLERY_CATEGORIES } from "../data/content";
import InstagramSection from "../components/InstagramSection";

export default function Gallery() {
  const [active, setActive] = useState("All");
  const items = active === "All" ? GALLERY : GALLERY.filter((g) => g.category === active);

  return (
    <div data-testid="gallery-page" className="bg-bone">
      <section className="pt-28 lg:pt-36 pb-16 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow text-gold mb-3">Gallery</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-white text-balance max-w-3xl">
            A taste of the presentation, variety & craft.
          </h1>
          <p className="mt-5 text-platinum text-lg max-w-2xl">
            Professional photography coming soon. Browse a preview of the flavors and experiences we bring to every table.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {GALLERY_CATEGORIES.map((c) => (
              <button key={c} data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g,'-')}`}
                onClick={() => setActive(c)}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                  active === c ? "bg-gold text-charcoal" : "bg-white border border-slate-200 text-slate-600 hover:border-gold"
                }`}>
                {c}
              </button>
            ))}
          </div>

          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]">
            {items.map((g, i) => (
              <div key={i} data-testid={`gallery-item-${i}`}
                className="mb-4 break-inside-avoid overflow-hidden rounded-2xl group relative">
                <img src={g.image} alt={`${g.category} — Taste of Platinum`} loading="lazy"
                  className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <span className="eyebrow text-gold">{g.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <InstagramSection />
    </div>
  );
}
